import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const { Row, Col, Spinner } = require("reactstrap");

const Performance = () => {
  const { t } = useTranslation();
  const { getProfileLoading, player } = useSelector((state) => state.Player);

  if (getProfileLoading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spinner color="primary" />
        <div>Chargement en cours...</div>
      </div>
    );
  }

  const performance = player?.performance;
  const trophies = performance?.trophies || [];
  const individualTitles = performance?.individualTitles || [];
  const stats = performance?.statistics || {};
  console.log(performance, trophies, individualTitles, stats);
  return (
    <div className="performance-component" style={{ marginTop: "20px" }}>
      <Row style={{ marginTop: "20px", marginLeft: "20px" }}>
        {/* Première Colonne */}
        <Col md={6}>
          {/* Trophées remportés */}
          <Row style={{ marginBottom: "20px" }}>
            <Col>
              <h5
                style={{
                  fontWeight: "bold",
                  color: "#0B2839",
                  font: "Poppins",
                }}
              >
                {t("playerInfo.Performance.trophies")}
              </h5>
              {trophies.length > 0 ? (
                <ul style={styles.ulStyle}>
                  {trophies.map((trophy, index) => (
                    <li key={index} style={styles.listeItem}>
                      {trophy}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={styles.noData}>
                  {t("playerInfo.Performance.emptyTrophies")}
                </p>
              )}
            </Col>
          </Row>

          {/* Titres individuels */}
          <Row>
            <Col>
              <h5
                style={{
                  fontWeight: "bold",
                  color: "#0B2839",
                  font: "Poppins",
                }}
              >
                {t("playerInfo.Performance.individualTitles")}
              </h5>
              {individualTitles.length > 0 ? (
                <ul style={styles.ulStyle}>
                  {individualTitles.map((title, index) => (
                    <li key={index} style={styles.listeItem}>
                      {title}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={styles.noData}>
                  {t("playerInfo.Performance.emptyIndividualTitles")}
                </p>
              )}
            </Col>
          </Row>
        </Col>

        {/* Deuxième Colonne */}
        <Col md={6}>
          <h5
            style={{
              fontWeight: "bold",
              color: "#0B2839",
              font: "Poppins",
              marginBottom: 40,
            }}
          >
            {t("playerInfo.Performance.keyStats")}
          </h5>

          <div style={styles.statInfo}>
            <span style={styles.titreInfo}>
              {t("playerInfo.Performance.golasNumber")} :
            </span>{" "}
            {stats.goalsScored ?? 0}
          </div>
          <div style={styles.statInfo}>
            <span style={styles.titreInfo}>
              {t("playerInfo.Performance.assists")} :
            </span>{" "}
            {stats.assists ?? 0}
          </div>
          <div style={styles.statInfo}>
            <span style={styles.titreInfo}>
              {t("playerInfo.Performance.minutesPlayed")} :
            </span>{" "}
            {stats.minutesPlayed ?? 0}
          </div>
          <div style={styles.statInfo}>
            <span style={styles.titreInfo}>
              {t("playerInfo.Performance.cardsReceived")} :
            </span>{" "}
            {stats.cardsReceived ?? 0}
          </div>
        </Col>
      </Row>
    </div>
  );
};
const styles = {
  titreInfo: {
    color: "#000000",
  },
  infoProfile: {
    marginBottom: "18px",
    fontSize: "18px",
    font: "Poppins",
  },
  ulStyle: {
    marginTop: 20,
    paddingLeft: "40px",
    color: "#555",
    marginRight: "20px",
  },

  statInfo: {
    marginBottom: "18px",
    fontSize: "16px",
    font: "Poppins",
  },
  listeItem: {
    marginBottom: 2,
  },
  noData: {
    color: "#999",
    paddingLeft: "10px",
    fontStyle: "italic",
  },
};

export default Performance;
